module.exports = __webpack_public_path__ + "static/media/KHOF01.f2894ca9.jpg";